
jQuery(document).ready(function ($) {

    AOS.init();

    function setElemHeight(targetElem) {
        var elementHeights = targetElem.map(function () {
            return $(this).height();
        }).get();

        var maxHeight = Math.max.apply(null, elementHeights);

        targetElem.height(maxHeight + 20);
    }

    $(window).on('scroll', function () {
        var scrollPos = $(window).scrollTop(),
            homePageHeight = $('body > section:first-of-type').height();

        $('body').toggleClass('header--fixed', (scrollPos > homePageHeight));

    });

    $('.navbar-toggler').on('click', function () {
        $('body').toggleClass('nav-open');
    });

    $('#scroll-btn').on("click", function (e) {
        e.preventDefault();

        $(document).off("scroll");

        var target = this.hash;
        $("html, body").stop().animate({
            scrollTop: $(target).offset().top - 90
        }, 800, 'swing', function () {
            // window.location.hash = target;
        });

    });

    var swiperServices = new Swiper(".services-swiper.swiper", {
        slidesPerView: 1,
        centeredSlides: true,
        loop: true,
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 3,
            }
        },
        navigation: {
            nextEl: ".services .swiper-button-next",
            prevEl: ".services .swiper-button-prev",
        },
    });

    var swiperClients = new Swiper(".clients-swiper.swiper", {
        spaceBetween: 30,
        slidesPerView: "auto",
        centeredSlides: true,
        loop: true,
        navigation: {
            nextEl: ".clients-swiper .swiper-button-next",
            prevEl: ".clients-swiper .swiper-button-prev",
        },
    });

    var swiperNews = new Swiper(".news-swiper.swiper", {
        spaceBetween: 20,
        slidesPerView: 1,
        centeredSlides: true,
        loop: true,
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 3,
            }
        },
        navigation: {
            nextEl: ".news .swiper-button-next",
            prevEl: ".news .swiper-button-prev",
        },
    });

    var priceRange = $(".price-range").ionRangeSlider({
        type: "double",
        // grid: true,
        min: 0,
        max: 4000,
        // from: 200,
        // to: 800,
        prefix: "",
        hide_min_max: true,
        hide_from_to: true,
        onStart: function (data) {
            // fired then range slider is ready
            var result = "£" + data.from + " - £" + data.to;
            $('#price-range-result').html(result);
        },
        onChange: function (data) {
            // fired on every range slider update
            var result = "£" + data.from + " - £" + data.to;
            $('#price-range-result').html(result);
        },
        onFinish: function (data) {
            // fired on pointer release
        },
        onUpdate: function (data) {
            // fired on changing slider with Update method
        }
    });

    var bedroomsNo = $("#bedrooms").ionRangeSlider({
        type: "double",
        min: 0,
        max: 10,
        prefix: "",
        hide_min_max: true,
        hide_from_to: true,
        onStart: function (data) {
            // fired then range slider is ready
            var result = data.from + " - " + data.to;
            $('#bedrooms-result').html(result);
        },
        onChange: function (data) {
            // fired on every range slider update
            var result = data.from + " - " + data.to;
            $('#bedrooms-result').html(result);
        },
        onFinish: function (data) {
            // fired on pointer release
        },
        onUpdate: function (data) {
            // fired on changing slider with Update method
        }
    });


   
    var nextBtn = $('#btn-next'),
        formFields1 = $('.form-fields-1'),
        formFields2 = $('.form-fields-2');

    nextBtn.on('click', function(e) {
        e.preventDefault();
        // if ( formFields1.find('input[name="postcode"]').val() !== "" && 
        //      formFields1.find('input[name="address"]').val() !== "" &&
        //      formFields1.find('input[name="subject"]').val() !== "" &&
        //      formFields1.find('select.menu-bedroom').val() !== "" ) {
                 formFields1.addClass('d-none');
                 formFields2.removeClass('d-none');
            // }
    });

});
